import React, { FunctionComponent } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import BlockRadioList from '../../components/BlockRadioList/BlockRadioList';
import CheckoutPreview from '../../components/CheckoutPreview/CheckoutPreview';
import { DonationFrequencyFormData } from '../../../types/givingCheckoutForm';
import { PAGES } from '../../constants/pages';
import Steps from '../../components/Steps/Steps';
import { useCharityData } from '../../context/charityContext';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import { useFormContext } from 'react-hook-form';
import { useHeadingSetFocusRef } from '../../hooks/useHeadingSetFocusRef';
import { useTranslation } from 'react-i18next';

const DonationFrequency: FunctionComponent = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const formMethods = useFormContext<DonationFrequencyFormData>();
  const { charity } = useCharityData();
  const { handleSubmit } = formMethods;
  const headingRef = useHeadingSetFocusRef();

  const onSubmit = handleSubmit(async (data) => {
    navigate(`${PAGES.CustomAmounts}${location.search}`);
  });

  useDocumentTitle(t('donationFrequency.heading'));

  return (
    <div className="giving-checkout-page">
      <div className="giving-checkout-page-form">
        <form noValidate method="post" onSubmit={onSubmit}>
          <Steps start={1} end={5} />
          <h1 className="jg-h3" ref={headingRef} tabIndex={-1}>
            {t('donationFrequency.heading')}
          </h1>
          <p className="jg-space-mblg jg-font-weight-regular jg-color--empress">
            {t('donationFrequency.description')}
          </p>

          <BlockRadioList
            name="donationFrequency"
            direction="column"
            items={[
              {
                title: t('donationFrequency.oneOff.title'),
                value: 'oneOff',
                description: t('donationFrequency.oneOff.description'),
              },
              {
                title: t('donationFrequency.monthly.title'),
                value: 'monthly',
                description: charity?.isMonthlyDisabled
                  ? t('donationFrequency.monthly.notAvailable')
                  : t('donationFrequency.monthly.description'),
                disabled: charity?.isMonthlyDisabled,
              },
            ]}
          />

          <button
            className="jg-btn"
            type="submit"
            data-qa="frequency-continue"
            data-track="frequency-continue"
          >
            {t('common.continue')}
          </button>
        </form>
      </div>
      <div className="giving-checkout-page-preview">
        <CheckoutPreview
          previewBlock={['cta', 'suggestedamounts', 'input', 'description']}
        />
      </div>
    </div>
  );
};

export default DonationFrequency;
